export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["ACQ0134"] = "acq01-acq-0134";
  ExperimentKeys["ONBU0025"] = "onbu-0025";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';